export default __webpack_public_path__ + "static/pro@992-430cb2f2920f60e20c3ea3a125d85117.jpg";